<div class="showcase-picture">
  <div class="header">
    <div class="title">
      {{"PAGES.ALLOCATION.SHOWCASE_PICTURE_DIALOG.TITLE" | translate}}
    </div>
  </div>
  <div class="body">

    <p class="text-value">
      {{('PAGES.ALLOCATION.SHOWCASE_PICTURE_DIALOG.TEXT.0' | translate)}}
      <!-- <br>
      {{('PAGES.ALLOCATION.SHOWCASE_PICTURE_DIALOG.TEXT.1' | translate)}} -->
    </p>

  </div>
  <div class="footer">

    <button (click)="closeDialog()">
      {{('PAGES.ALLOCATION.SHOWCASE_PICTURE_DIALOG.CONFIRM' | translate) | uppercase }}
    </button>
  </div>
</div>
